import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Boxes from '../components/Boxes';
import { getDeviceType, updateMetaTags } from '../utils/deviceDetection';

const MrGamb2025Page = () => {
  const [deviceType, setDeviceType] = useState('desktop');

  useEffect(() => {
    const currentDeviceType = getDeviceType();
    setDeviceType(currentDeviceType);
    updateMetaTags(currentDeviceType);
  }, []);

  return (
    <div className="App">
      <Header deviceType={deviceType} />
      <Boxes deviceType={deviceType} />
    </div>
  );
};

export default MrGamb2025Page;
